const PscRisk: { [key: string]: { color: string; text: string } } = {
    '1': {
        // High Risk
        color: '#DA1F33',
        text: 'High'
    },
    '2': {
        // Medium Risk
        color: '#FFAD0A',
        text: 'Medium'
    },
    '3': {
        // Low Risk
        color: '#418cd1',
        text: 'Low'
    }
};

export default PscRisk;
